import { takeLatest } from "redux-saga";
import { call, select } from "redux-saga/effects";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

import { TOGGLE_SAVE_PLAN, CLEAR_ALL_COMPARE_PLANS, getSavedPlanIDs } from "./redux";

import type { EmployerRenewalCompanyProfile } from "Utils/types";

function updateSavedPlansApi(savedPlanIDs: Array<string>, companyProfile: EmployerRenewalCompanyProfile) {
  const payload = savedPlanIDs;
  const url = `/small-group/select-plan/update-saved-plans?company_id_token=${companyProfile.id_token}&savedPlans=${JSON.stringify(payload)}`;
  return fetchWithCSRFToken(url, { method: "POST", processData: false }).then((response) => response.json());
}
/// ///////////////////////////////////////////////////

function* updateSavedPlans() {
  const savedPlanIDs = yield select(getSavedPlanIDs);
  const companyProfile = yield select((state) => state.companyProfile);

  yield call(updateSavedPlansApi, savedPlanIDs, companyProfile);
}

export function* SavedPlanSaga(): Generator<any, any, any> {
  yield takeLatest(TOGGLE_SAVE_PLAN, updateSavedPlans);
  yield takeLatest(CLEAR_ALL_COMPARE_PLANS, updateSavedPlans);
}
